import { FeatureFlag } from '@sonar-software/sonar-core';
import { JiraIcon } from '@ui/icons';
import React from 'react';
import { ViewAreaSidebar } from '@ui/general';
import { CloudOutlined, SlackOutlined, SyncOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
const menuItems = [
    {
        icon: React.createElement(UserOutlined, null),
        key: FULL_ROUTES.SETTINGS_USER,
        label: COPY_SPECIFIC.USER
    },
    {
        icon: React.createElement(TeamOutlined, null),
        key: FULL_ROUTES.SETTINGS_TEAM,
        label: COPY_SPECIFIC.TEAM
    },
    {
        icon: React.createElement(CloudOutlined, null),
        key: FULL_ROUTES.SETTINGS_ORGANIZATION,
        label: COPY_SPECIFIC.SALESFORCE_ORGS
    },
    {
        icon: React.createElement(SlackOutlined, null),
        key: FULL_ROUTES.SETTINGS_SLACK,
        label: COPY_SPECIFIC.SLACK
    },
    {
        feature: FeatureFlag.JiraIntegration,
        icon: React.createElement(JiraIcon, null),
        key: FULL_ROUTES.SETTINGS_JIRA,
        label: COPY_SPECIFIC.JIRA
    },
    {
        icon: React.createElement(SyncOutlined, null),
        id: 'sync-menu-item',
        key: FULL_ROUTES.SYNC,
        label: COPY_SPECIFIC.METADATA_IMPORT,
        route: FULL_ROUTES.SYNC
    }
];
export const SettingsSidebar = () => React.createElement(ViewAreaSidebar, { id: 'settings-sidebar', items: menuItems });
